import { Component, Input, inject } from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {CharacteristicService} from "../../../administration/characteristic/characteristic.service";
import {IncomeTypeService} from "../../../administration/income-type/income-type.service";
import {FamilyStatusService} from "../../../administration/family-status/family-status.service";
import {NationalityService} from "../../../administration/nationality/nationality.service";

@Component({
    selector: 'app-internal-form',
    templateUrl: './internal-form.component.html',
    styleUrls: ['./internal-form.component.scss'],
    standalone: false
})
export class InternalFormComponent {
  characteristicService = inject(CharacteristicService);
  incomeTypeService = inject(IncomeTypeService);
  familyStatusService = inject(FamilyStatusService);
  nationalityService = inject(NationalityService);


  @Input() internalForm!: FormGroup;

  get characteristicsFormArray() {
    return this.internalForm.get('characteristics') as FormArray;
  }

}
